<template>
  <header class="site-header" :class="{ 'scrolled': isScrolled }">
    <div class="container">
      <div class="logo">
        <router-link to="/">Paradisa Studenté</router-link>
      </div>
      <nav class="main-nav" :class="{ 'is-open': isMenuOpen }">
        <ul>
          <li><router-link to="/" @click="closeMenu">Home</router-link></li>
          <li><router-link to="/peluang-investasi" @click="closeMenu">Peluang Investasi</router-link></li>
          <li><router-link to="/tentang-proyek" @click="closeMenu">Tentang Proyek</router-link></li>
        </ul>
      </nav>
      <div class="header-cta">
        <a href="https://wa.me/6281234567890?text=Halo, saya tertarik dengan investasi di Paradisa Studenté." target="_blank" class="cta-button">Hubungi Kami</a>
      </div>
      <button class="menu-toggle" @click="toggleMenu" :class="{'is-active': isMenuOpen}">
        <span></span>
        <span></span>
        <span></span>
      </button>
    </div>
  </header>
</template>

<script>
import { ref, onMounted, onUnmounted } from 'vue';

export default {
  name: 'SiteNavbar',
  setup() {
    const isMenuOpen = ref(false);
    const isScrolled = ref(false);

    const toggleMenu = () => {
      isMenuOpen.value = !isMenuOpen.value;
    };
    
    const closeMenu = () => {
      isMenuOpen.value = false;
    };

    const handleScroll = () => {
      isScrolled.value = window.scrollY > 10;
    };

    onMounted(() => {
      window.addEventListener('scroll', handleScroll);
    });

    onUnmounted(() => {
      window.removeEventListener('scroll', handleScroll);
    });

    return {
      isMenuOpen,
      isScrolled,
      toggleMenu,
      closeMenu
    };
  }
}
</script>

<style scoped>
.site-header {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 1000;
  padding: 15px 0;
  transition: background-color 0.3s ease, box-shadow 0.3s ease, padding 0.3s ease;
}
.site-header.scrolled {
  background-color: #fff;
  box-shadow: 0 2px 10px rgba(0,0,0,0.1);
  padding: 10px 0;
}
.container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}
.logo a {
  font-size: 1.5rem;
  font-weight: 700;
  color: var(--primary-color);
  text-decoration: none;
}
.site-header.scrolled .logo a {
  color: var(--primary-color);
}
.main-nav ul {
  display: flex;
  list-style: none;
  margin: 0;
  padding: 0;
  gap: 30px;
}
.main-nav a {
  text-decoration: none;
  color: #333;
  font-weight: 500;
  position: relative;
  padding: 5px 0;
}
.main-nav a::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  width: 0;
  height: 2px;
  background-color: var(--secondary-color);
  transition: width 0.3s ease;
}
.main-nav a:hover::after, .main-nav a.router-link-exact-active::after {
  width: 100%;
}
.header-cta .cta-button {
  padding: 8px 20px;
  font-size: 14px;
}
.menu-toggle {
  display: none;
  background: none;
  border: none;
  cursor: pointer;
  width: 30px;
  height: 22px;
  position: relative;
}
.menu-toggle span {
  display: block;
  width: 100%;
  height: 3px;
  background-color: var(--primary-color);
  border-radius: 3px;
  position: absolute;
  transition: all 0.3s ease;
}
.menu-toggle span:nth-child(1) { top: 0; }
.menu-toggle span:nth-child(2) { top: 9px; }
.menu-toggle span:nth-child(3) { bottom: 0; }
.menu-toggle.is-active span:nth-child(1) { transform: rotate(45deg); top: 9px; }
.menu-toggle.is-active span:nth-child(2) { opacity: 0; }
.menu-toggle.is-active span:nth-child(3) { transform: rotate(-45deg); top: 9px; }

@media (max-width: 992px) {
  .main-nav {
    position: fixed;
    top: 60px; /* Sesuaikan dengan tinggi header.scrolled */
    left: 0;
    width: 100%;
    height: calc(100vh - 60px);
    background-color: rgba(255,255,255,0.98);
    backdrop-filter: blur(5px);
    transform: translateX(-100%);
    transition: transform 0.3s ease-in-out;
  }
  .main-nav.is-open {
    transform: translateX(0);
  }
  .main-nav ul {
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 100%;
    gap: 20px;
  }
  .main-nav a { font-size: 1.5rem; }
  .header-cta { display: none; }
  .menu-toggle { display: block; }
}
</style>